import React from "react";

import { AdminUserAddress, AdminUserProfile } from '../AdminUserControl/AdminUserControl';

import { ViewType } from '../../Utilities/Enums/ViewTypeEnum';
import { AuthenticationField, ImageFileField, SignUpField, PasswordForgotField } from '../../Utilities/Enums/ParametersEnum';
import { CurrencyEnum } from '../../Utilities/Enums/CurrencyEnums';
import { RoleTypeEnum } from '../../Utilities/Enums/RolesEnums';

export class Authentication {
    [AuthenticationField.ACCESSIBILITIES]?: any | null = [];
    [AuthenticationField.NAME]?: string | null = null;
    [AuthenticationField.USERNAME]?: string | null = null;
    [AuthenticationField.UNAME]?: string | null = null;
    [AuthenticationField.ROLE_PUBLIC_ID]?: string | number = "";
    [AuthenticationField.ROLE_NAME]?: string = "";
    [AuthenticationField.TOKEN]?: string = "";
    [AuthenticationField.PUBLIC_ID]?: string | number = "";
    [AuthenticationField.CURRENCY_CODE]?: CurrencyEnum = CurrencyEnum.PHP;
    [AuthenticationField.MUST_CHANGE_PASSWORD]?: boolean = false;
    [AuthenticationField.ROLE_TYPE]?: RoleTypeEnum = RoleTypeEnum.DEFAULT;
    [AuthenticationField.VENDORS]?: any | null = null;
    [AuthenticationField.COMPANY_NAME]?: string = "";
    [AuthenticationField.VENDOR_NAME]?: string = "";

    constructor(obj?: Partial<Authentication>) {
        Object.assign(this, obj);
    }
}

export class SignUpUser {
    [SignUpField.REGISTRATION_CODE]?: string = "";
    [SignUpField.ROLE_PUBLIC_ID]?: string | number | null = null;
    [SignUpField.STATUS]?: number = 0;
    [SignUpField.USERNAME]?: string = "";
    [SignUpField.USER_EMAIL]?: string = "";
    [SignUpField.USER_CONTACT_NUMBER]?: string = "";
    [SignUpField.PASSWORD]?: string = "";
    [SignUpField.ENABLE_2FA]?: boolean = false;
    [SignUpField.PROFILE]?: AdminUserProfile = new AdminUserProfile();
    [SignUpField.ACCOUNT_TYPE]?: string | number | null = null;
    [SignUpField.RECAPTCHA_KEY]?: string = "";
    [SignUpField.ADDRESS]?: AdminUserAddress = new AdminUserAddress();
    [SignUpField.VENDOR_REGISTRATION_CODE]?: string = "";

    constructor(obj?: Partial<SignUpUser>) {
        Object.assign(this, obj);
    }
}

export class PasswordForgot {
    [PasswordForgotField.USER_EMAIL]?: string = "";

    constructor(obj?: Partial<PasswordForgot>) {
        Object.assign(this, obj);
    }
}